import * as Yup from 'yup';

/* VALIDAÇÃO PARA EVENTOS */
export const SaidaEventoValidationSchema = Yup.object().shape({
	isEvento: Yup.string().required('Campo obrigatório'),
	id: Yup.string()
		.required('Campo obrigatório'),
	ocorrencia: Yup.object().shape({
		id: Yup.number().min(1, 'Campo obrigatório'),
	}),
	quantidadeSaida: Yup.number().min(1, 'Quantidade deve ser maior que 0').required('Campo obrigatório'),
});

/* VALIDAÇÃO PARA NÃO EVENTOS */
export const SaidaNaoEventoValidationSchema = Yup.object().shape({
	isEvento: Yup.string().required('Campo obrigatório'),
	id: Yup.string()
		.required('Campo obrigatório'),
	motivo: Yup.string().trim().required('Campo obrigatório'),
	documento: Yup.string().nullable().required('Campo obrigatório'),
	quantidadeSaida: Yup.number().min(1, 'Quantidade deve ser maior que 0')
		.required('Campo obrigatório'),

});
